import React from 'react';
interface ProgressBarProps {
  progress: number; // 0 to 100
  color?: string;
  height?: number;
  showPercentage?: boolean;
  className?: string;
}
export const ProgressBar = ({
  progress,
  color = 'bg-blue-500',
  height = 8,
  showPercentage = false,
  className = ''
}: ProgressBarProps) => {
  const clampedProgress = Math.min(100, Math.max(0, progress));
  return <div className={`w-full ${className}`} data-id="element-1544">
      <div className="w-full bg-gray-200 rounded-full overflow-hidden" style={{
      height: `${height}px`
    }} data-id="element-1545">
        <div className={`${color} transition-all duration-300 ease-in-out`} style={{
        width: `${clampedProgress}%`,
        height: `${height}px`
      }} data-id="element-1546" />
      </div>
      {showPercentage && <div className="text-sm text-gray-600 mt-1" data-id="element-1547">{clampedProgress}%</div>}
    </div>;
};